import useSWR from 'swr';
import axiosConfig from '@/data/utils/axiosConfigInstance';

const fetcher = async ([url, params]) => {
	const searchParams = buildSearchParams(params);
	const query = searchParams.toString();
	const endpoint = query ? `${url}?${query}` : url;
	const response = await axiosConfig.get(endpoint);
	return response.data;
};

function buildSearchParams(params = {}) {
	const search = new URLSearchParams();
	const {
		page,
		pageSize,
		sortBy,
		sortOrder,
		email,
		eventAction,
		collection,
		operationType,
		startDate,
		endDate
	} = params;

	if (page) search.set('page', page);
	if (pageSize) search.set('limit', pageSize);
	if (sortBy) search.set('sortBy', sortBy);
	if (sortOrder) search.set('sortOrder', sortOrder);
	if (email) search.set('email', email.trim());
	if (operationType) search.set('operationType', operationType);

	const toList = value => {
		if (!value) return [];
		if (Array.isArray(value)) return value.filter(Boolean);
		return String(value)
			.split(',')
			.map(v => v.trim())
			.filter(Boolean);
	};

	const listToCsv = value => {
		const items = toList(value);
		return items.length ? items.join(',') : '';
	};

	const normalizedEventActions = listToCsv(eventAction);
	const normalizedCollections = listToCsv(collection);

	if (normalizedEventActions) search.set('eventAction', normalizedEventActions);
	if (normalizedCollections) search.set('collection', normalizedCollections);

	const normalizeDate = value => {
		if (!value) return null;
		const date = value instanceof Date ? value : new Date(value);
		if (Number.isNaN(date.getTime())) return null;
		return date.toISOString();
	};

	const startISO = normalizeDate(startDate);
	const endISO = normalizeDate(endDate);
	if (startISO) search.set('startDate', startISO);
	if (endISO) search.set('endDate', endISO);

	return search;
}

export function useAuditLogs(params) {
	const swr = useSWR(['/audit-logs', params], fetcher, {
		revalidateOnFocus: false,
		keepPreviousData: true
	});

	return {
		data: swr.data?.data || [],
		meta: swr.data?.meta || { page: params?.page || 1, limit: params?.pageSize || 20, total: 0, totalPages: 0 },
		isLoading: swr.isLoading,
		isError: Boolean(swr.error),
		error: swr.error,
		mutate: swr.mutate
	};
}

export function buildAuditLogQuery(params) {
	return buildSearchParams(params).toString();
}
